import { render, staticRenderFns } from "./gerar-receita-excel.vue?vue&type=template&id=4ed49da8&scoped=true&"
import script from "./gerar-receita-excel.vue?vue&type=script&lang=js&"
export * from "./gerar-receita-excel.vue?vue&type=script&lang=js&"
import style0 from "./gerar-receita-excel.vue?vue&type=style&index=0&id=4ed49da8&lang=scss&scoped=true&"
import style1 from "./gerar-receita-excel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed49da8",
  null
  
)

export default component.exports